<template>
  <div class="stop-entry">
    <div class="stop-info">
      <span class="stop-ref">{{ stopObj.reference }}</span>
      <h3 class="stop-name">{{ stopObj.details?.stop?.fullname || 'Unknown Stop' }}</h3>
    </div>
    
    <div class="routes-container">
      <h4 class="section-title">Routes</h4>
      <div v-if="stopObj.details?.routes?.to" class="dest-list">
        <StopPanelDestination 
          v-for="(tostop, toreference) in stopObj.details.routes.to" 
          :key="toreference"
          :tostop="tostop" 
          :stopData="stopObj.details"
          :fromRef="stopObj.reference"
          :toRef="toreference"
        />
      </div>
      <div v-else class="no-routes">No outgoing routes found.</div>
    </div>
  </div>
</template>

<script setup>
import { inject, defineProps, provide } from 'vue';
import StopPanelDestination from './StopPanelDestination.vue';

const props = defineProps({
  stopObj: {
    type: Object,
    required: true
  }
});

const stateData = inject('stateData');
provide('stateData', stateData);

</script>

<style scoped>
.stop-entry {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.stop-info {
  display: flex;
  flex-direction: column;
}

.stop-ref {
  font-family: 'JetBrains Mono', monospace;
  font-size: 0.75rem;
  color: #367530;
  font-weight: bold;
}

.stop-name {
  margin: 0;
  font-size: 1.1rem;
  color: #eee;
  line-height: 1.2;
}

.section-title {
  margin: 8px 0;
  font-size: 0.8rem;
  text-transform: uppercase;
  color: #888;
  letter-spacing: 1px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
  padding-bottom: 4px;
}

.dest-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.no-routes {
  font-size: 0.8rem;
  color: #666;
  font-style: italic;
}
</style>